import { isProductionEnvironment } from "@remi/environment";

import { hasCapability, type User } from "../base";

export const impersonation = {
  create: (user: User) => {
    return isProductionEnvironment() ? hasCapability(user, "impersonation.create") : true;
  },
  // Capabilities resolve from the impersonated person mid-session, so the acting admin lives in `imposter`, not `person`.
  end: (user: User & { imposter?: User["person"] }) => impersonation.create({ person: user.imposter ?? user.person }),
};
